import { render, staticRenderFns } from "./sport-options.vue?vue&type=template&id=4861deee&scoped=true&"
import script from "./sport-options.vue?vue&type=script&lang=js&"
export * from "./sport-options.vue?vue&type=script&lang=js&"
import style0 from "./sport-options.vue?vue&type=style&index=0&id=4861deee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861deee",
  null
  
)

export default component.exports